import PlotlyChart from './PlotlyChart';
import { COLORS, mergeLayout, mergeConfig } from '../utils/chartTheme';

export default function LineChart({ data, chartOptions = {}, dimensionInfo }) {
  const { nameFn = (x, _d) => x } = chartOptions

  const traces = data.map((trace, i) => ({
    x: trace.x,
    y: trace.y,
    type: 'scatter',
    mode: 'lines',
    name: nameFn(trace.name, dimensionInfo),
    line: {
      color: COLORS[i % COLORS.length],
      width: 2.5,
      shape: 'linear',
    },
    hovertemplate: '%{y}<extra>%{fullData.name}</extra>',
  }))

  const layout = mergeLayout({
    ...(chartOptions.title ? { title: { text: chartOptions.title, font: { size: 15, color: '#334155' }, x: 0, xanchor: 'left', pad: { l: 4 } } } : {}),
    ...(chartOptions.layout || {}),
  })

  return (
    <PlotlyChart
      data={traces}
      useResizeHandler={true}
      layout={layout}
      config={mergeConfig()}
      style={{ width: '100%', height: '400px' }}
    />
  );
}
